import React from 'react';
import PDFSubmissionPage from '../../../features/off-page/pdf-submission/PDFSubmissionPage';

interface PDFSubmissionWrapperProps {
  onBack: () => void;
  darkMode: boolean;
  userId: string;
}

export default function PDFSubmissionWrapper({ onBack, darkMode, userId }: PDFSubmissionWrapperProps) {
  return <PDFSubmissionPage onBack={onBack} darkMode={darkMode} userId={userId} />;
}
